// Copyright (c) 2017 Deere & Company

import ActionsPopoverCallback from '../../../shared/state/actions-popover-callback';
import ActionsPopoverLink from '../../../shared/state/actions-popover-link';
import {downloadSmartForm} from '../../../shared/services/download-smart-form';
import {hasAccess} from '../../../shared/services/security';

const createLink = (label, route) =>
    new ActionsPopoverLink({
        label,
        route
    });

const createCallBack = (label, onOptionClick, onOptionClickValues) =>
    new ActionsPopoverCallback({
        label,
        onOptionClick,
        onOptionClickValues
    });

const printClaim = claimNumber => {

    downloadSmartForm('CLAIM', claimNumber);

};

export const getRecordAuditActions = (data, fullDebitCallback, security) => {

    const actionList = [];

    actionList.push(createCallBack('PRINT_CLAIM', printClaim, data.claim.claimNumber));

    actionList.push(createLink('VIEW_CLAIM', data.route));

    if (hasAccess(security, 'TCSM', 'TCSM_DEBIT_PROCESS')) {

        actionList.push(createCallBack('FULL_DEBIT', fullDebitCallback, {claimNumber: data.claim.claimNumber}));

        actionList.push(createLink('PARTIAL_DEBIT', `/tcsm/audits/record/partial-debit?claimNumber=${data.claim.claimNumber}&auditNumber=${data.auditNumber}`));

        actionList.push(createLink('PERCENTAGE_DEBIT', `/tcsm/audits/record/percentage-debit?claimNumber=${data.claim.claimNumber}&auditNumber=${data.auditNumber}`));

    }

    return actionList;

};



// WEBPACK FOOTER //
// ./src/tcsm/record-audit/services/record-audit-helper.js